/* „Behind the Frame" — deschiderea filmului pe tot ecranul, cu sunet.
 * Nimic nu se descarca pana la clic: cardul e doar o imagine.
 * Regula de baza: nimic de aici n-are voie sa opreasca pagina.
 */
(function () {
  'use strict';

  function open(src, name) {
    var m = document.createElement('div');
    m.className = 'lnxs-modal';
    m.innerHTML =
      '<div class="lnxs-modal__bg"></div><div class="lnxs-modal__box">' +
      '<button class="lnxs-modal__close" aria-label="Închide">&times;</button>' +
      '<video controls playsinline preload="auto"></video>' +
      '<p class="lnxs-modal__name"></p></div>';
    document.body.appendChild(m);
    document.body.classList.add('lnxs-open');

    var v = m.querySelector('video');
    v.src = src;
    m.querySelector('.lnxs-modal__name').textContent = name || '';

    /* clicul pe card e gestul care deblocheaza sunetul; daca browserul refuza
       tot, ramane cu controalele la vedere si omul apasa el */
    var p = v.play();
    if (p && p.catch) p.catch(function () {});

    function close() {
      try { v.pause(); } catch (e) {}
      m.remove();
      document.body.classList.remove('lnxs-open');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    m.querySelector('.lnxs-modal__close').addEventListener('click', close);
    m.querySelector('.lnxs-modal__bg').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var card = t.closest('[data-lnxs-play]');
      if (!card) return;
      e.preventDefault();
      open(card.getAttribute('data-lnxs-play'), card.getAttribute('data-lnxs-name'));
      if (typeof window.ergolivTrack === 'function') {
        window.ergolivTrack('story_play', card.getAttribute('data-lnxs-name') || '', {});
      }
    } catch (err) { /* niciodata nu stricam pagina */ }
  }, true);
})();
